const images = document.querySelectorAll('.js-solution-image')
const titles = document.querySelectorAll('.js-solution-title')
const btngallery = document.querySelector('.js-solution-btn')

if (images) {

 images.forEach((item, index) => {
  if (index !== 0) item.classList.add('is-hidden')
  else item.classList.add('is-active')
  })
}

if (titles) {
  titles.forEach((btn, index) => {
    btn.addEventListener('mouseover', () => {
      document.querySelector('.js-solution-image.is-active').classList.add('is-hidden')
      images[index].classList.remove('is-hidden')
      btngallery.href = btn.dataset.url 
      btngallery.querySelector('span').innerHTML = btn.dataset.label 

      setTimeout(() => {
        document.querySelector('.js-solution-image.is-active').classList.remove('is-active')
        images[index].classList.add('is-active')
      }, 100)
    })
  })
}